import { createAction } from "@reduxjs/toolkit";

export const setNotification = createAction("SET_NOTIFICATION@notification");

export const resetNotification = createAction("RESET_NOTIFICATION@notification");
